export default {
  common: {
    account: 'account',
    return: 'Back'
  },
  button: {
    returnTop: 'Back to top',
    rangeSelect: 'Select ride section & time',
    busSelect: 'Select a bus',
    reserveConfirm: 'Confirm reservation',
    reserveCancel: 'Cancel reservation'
  },
  view: {
    ticket: 'Ticket',
    fromAirport: 'From the airport',
    toAirport: 'To the airport',
    directionDep: 'Departure',
    directionDepDesc: 'Airport → Destination',
    directionArr: 'Arrival',
    directionArrDesc: 'Destination → Airport',
    pleaseSelectBus: 'Please select a bus',
    availablePeriod: 'Available period',
    useInstruction: 'Usage introduction',
    adultCount: 'Adult × {{count}}',
    childCount: 'Child × {{count}}',
    disabledAdultCount: 'Persons with disabilities (adults)  × {{count}}',
    rangeAndSchedule: 'Select ride section & boarding date',
    pleaseSelect: 'Please select',
    ridingDate: 'Boarding date',
    ridingPlace: 'Departing from',
    departurePlace: 'Boarding place',
    arrivalPlace: 'Arrive at',
    company: 'Operation company',
    availableSeatsCount: 'Available seats',
    ridingBusTime: 'Bus time',
    buyTicket: 'Purchased tickets',
    reservationRideInfo: 'Reservation details',
    inReserve: 'Reservation in progress',
    thankForReservation: 'Thank you for making a reservation.',
    reservationConfirmed: 'Please find your reservation details below.',
    inCancel: 'Cancellation in progress.',
    cancelInfo: 'Cancellation information',
    isCanceled: 'Your reservation has been canceled. ',
    notAvailableBus:
      'There are no buses available for the section or boarding date you have selected.',
    currentJapanTime: 'Current time in Japan: {{time}}',
    baseJapanTime: 'The time given below is based on the Japan Standard Time.',
    remainsCount: 'remaining seats'
  }
};
